
export class VendorInsurancePolicyDocumentModel {
    public id: number;
    public vendorId: number;
    public originalFileName: string;
    public fileName: string;
    public fileUrl: string;
}
